



























import { Component, Vue, Prop } from 'vue-property-decorator';
import axios from 'axios';
import { General } from '@/services/General';
import { IMaterialDto } from '@/interfaces/IMaterialDto';
import { ProductBase } from '@/entity/ProductBase';
import { MaterialPrintElementBase, MaterialProductDetailBase } from '@/entity/MaterialBase';

@Component
export default class MaterialDetail extends Vue {

    @Prop({
        type: Boolean,
        required: false,
        default: false
    })
    editProductMode: boolean;

    @Prop({
        required: false
    })
    product: ProductBase;

    @Prop({
        required: false
    })
    materialToProcessProp: any;

    @Prop({
        required: false
    })
    materialListNewProduct: MaterialPrintElementBase[];

    materialToProcess =  {} as IMaterialDto;
    materialCodeTemp: string = '';
    loading: boolean = false;
    isSaveClicked: boolean = false;
    materialDetailModalTitle: string = '';

    mounted() {
        this.materialToProcess = this.materialToProcessProp;
        this.materialCodeTemp = this.materialToProcessProp.materialCode;     
    }

    returnState(condition: boolean, clickButton: boolean): boolean {
        if (clickButton) 
            return condition;
        else 
            return null;
    }

    async processMaterialManual(){
        this.isSaveClicked = true;
        if (!this.materialToProcess.materialCode || !this.materialToProcess.originalDescription) {
            General.showAlertDanger("Please check Required fields", this);
        } else if (!this.product.Code) {
            General.showAlertDanger("Please, insert Product Code First", this);
        } else if(!this.materialToProcess.materialCode.includes(this.product.Code)) {
            General.showAlertDanger("Invalid Material Code: does not include Product Code", this);
        } else if(this.materialToProcess.materialCode.length > 15) {
            General.showAlertDanger("Invalid Material Code: max 15 characters length", this);
        } else {
            if(this.editProductMode){
                if(this.materialToProcess.idMaterial === undefined) {
                    let app = this;
                    let callSaving = async () =>  {
                        await app.addMaterialManualDo();
                    }
                    General.confirm('Please confirm that you want to add this Material.', app, callSaving);
                } else {
                    let app = this;
                    let callSaving = async () =>  {
                        await app.editMaterialManualDo();
                    }
                    General.confirm('Please confirm that you want to edit this Material.', app, callSaving);
                }
            } else {
                if(this.materialListNewProduct.findIndex(x => x.materialCode === this.materialToProcess.materialCode) >= 0
                    && this.materialCodeTemp != this.materialToProcess.materialCode) {
                    General.showAlertDanger("Material code already added", this);
                } else {
                    let app = this;
                    let callSaving = async () =>  {
                        await app.returnMaterialToListDo();
                    }
                    General.confirm('Please confirm that you want to edit Material list.', app, callSaving);
                }
            }
        }
    }

    async returnMaterialToListDo() {
        this.loading = true;
        try {
            let material = await this.GetMaterialInfoByCodeAndDescription()
            this.$emit('afterMaterialDetail', material, this.materialCodeTemp);
            General.showAlertSuccess("Material list successfully updated.", this);
        } catch(error) {
            General.HandleError(error, this, true);
        } finally {
            this.loading = false;
            this.isSaveClicked = false;
        }
    }

    async GetMaterialInfoByCodeAndDescription() : Promise<MaterialPrintElementBase> {
        let materialInfo: MaterialPrintElementBase = null;
        let response = await axios.post<MaterialPrintElementBase>(
            General.GetApiUrl("/api/Material/GetMaterialInfoByCodeAndDescription"),
            {
                materialCode: this.materialToProcess.materialCode,
                description: this.materialToProcess.originalDescription
            },
            {
                withCredentials: true
            }
        );
        materialInfo = {materialCode: response.data.materialCode
                                , description: response.data.description
                                , originalDescription: response.data.originalDescription
                                , packageCode: response.data.packageCode
                                , isDead: response.data.isDead
                                , isPhaseOut: response.data.isPhaseOut
                                , idMaterial: (this.materialToProcess.idMaterial ? this.materialToProcess.idMaterial : '')
                                , barCode: response.data.barCode
                                , product: new MaterialProductDetailBase({techSpecs: '', viscosity: '', approvals: '', performanceLevel: ''})};
        return materialInfo;
    }

    async addMaterialManualDo() {
        this.loading = true;
        try {
            let response = await axios({
                method: "post",
                url: General.GetApiUrl("/api/Material/AddMaterial"),
                withCredentials: true,
                data: {
                    idProduct: this.product.IdProduct,
                    materialCode: this.materialToProcess.materialCode,
                    description: this.materialToProcess.originalDescription,
                }
            });
            this.$emit('afterMaterialDetail');
            General.showAlertSuccess("Material successfully added.", this);
        } catch(error) {
            General.HandleError(error, this, true);
        } finally {
            this.loading = false;
            this.isSaveClicked = false;
        }
    }

    async editMaterialManualDo() {
        this.loading = true;
        try {
            let response = await axios({
                method: "put",
                url: General.GetApiUrl("/api/Material/UpdateMaterial"),
                withCredentials: true,
                data: {
                    idMaterial: this.materialToProcess.idMaterial,
                    idProduct: this.product.IdProduct,
                    materialCode: this.materialToProcess.materialCode,
                    description: this.materialToProcess.originalDescription
                }
            });
            this.$emit('afterMaterialDetail');
            General.showAlertSuccess("Material successfully updated", this);
        } catch(error) {
            General.HandleError(error, this, true);
        } finally {
            this.loading = false;
            this.isSaveClicked = false;
        }
    }
}
